<ul class="mt-4">

    <li *ngFor="let item of dataSource;let index = index" class="my-4 ">
        <div *ngIf="index < 2">
            <h3 class="text-base font-bold">{{item.Title}}</h3>
            <div [innerHTML]="item.Description" class="text-black-300 text-base mt-2 leading-8"></div>
        </div>
        <div *ngIf="index > 2" class="{{showCollapseInfo  ? 'block' : 'hidden'}} ">
            <h3 class="text-base font-bold">{{item.Title}}</h3>
            <div [innerHTML]="item.Description" class="text-black-300 text-base mt-2 leading-8"></div>
        </div>

    </li>
</ul>

<div class="w-full float-left text-left">
    <button class="text-blue-500 flex items-center float-left" (click)="showCollapseInfo = !showCollapseInfo">
        مشاهده {{showCollapseInfo ? 'کمتر' : 'بیشتر'}}
        <i class="{{showCollapseInfo ? 'ico-Up' : 'ico-Down'}}  text-2xl"></i>
    </button>
</div>
  